import { Component, OnInit } from '@angular/core';
import { TematicService } from 'src/app/services/obs/tematic.service';
import { Tematic } from 'src/app/models/obs/tematic';
import { Message } from 'src/app/models/message';
import { AccessService } from 'src/app/services/access.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { BackendResponse, ResponseTematic } from 'src/app/models/obs/apiResponse';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-admtematics-list',
  templateUrl: './admtematics-list.component.html',
  styleUrl: './admtematics-list.component.scss'
})
export class AdmtematicsListComponent implements OnInit {

  result: any;
  t2: Tematic[];
  msg: Message = null;

  constructor(
    private t2Service: TematicService,
    private accesService: AccessService,
    private ts: TokenStorageService
  ) { }

  ngOnInit() {
    this.getTematics();
    this.getPermission();
  }

  getTematics() {
    this.t2Service.getAll().subscribe({
      next: (res: BackendResponse<ResponseTematic>) => {
        this.result = res;
        this.t2 = res.data;
      },
      error: err => {
        this.msg = err;
      }
    });
  }

  //bandera que identifica al modulo
  accessMP = {}
  /* Permite determinar si el usuario actual tiene permiso para el modulo */
  inf = {}
  getPermission() {
    this.inf['userId'] = this.ts.getUser().id;
    this.inf['accessId'] = 11;
    const data = this.inf;
    this.accesService.getPermissionUser(data).subscribe({
      next: res => {
        this.accessMP = res['data']
      },
      error: err => {
        this.msg = err;
      }
    });
  }
}
